import React, { useState, useEffect } from 'react'
import axios from 'axios'

import cogniLogo from '../../images/cogni_logo.png'
import SuccessImage from '../../images/success.png'
import '../signup/signup.css'

let currentTimer = undefined

export const ForgotEmailSuccess = (props) => {
    const [timer, setTimer] = useState({ show: false, timer: 179 })

    const [invalidEmail, setEmailAsInvalid] = useState({ show: false, msg: '' })

    const startTimer = () => {
        if (!currentTimer) {
            currentTimer = setInterval(() => {
                setTimer({ show: true, timer: timer.timer-- })
            }, 1000)
        }
    }

    const reSend = (email) => {
        return axios
            .post(`${process.env.REACT_APP_PASSWORD_RESET_VERIFICATION_URL}`, {
                email,
            })
            .then(startTimer)
            .catch((err) => {
                if (err.response.status === 400) {
                    if (
                        err.response.data.user_already_exists ||
                        err.response.data.attemptOver
                    ) {
                        setEmailAsInvalid({
                            show: true,
                            msg: err.response.data.message,
                        })
                    }
                }
            })
    }

    useEffect(() => {
        if (timer.timer === 0) {
            clearIntervals()
            setTimer({ show: false, timer: 179 })
        }
    }, [timer.timer])

    const clearIntervals = () => {
        currentTimer && clearInterval(currentTimer)
        currentTimer = null
    }

    return (
        <span className="signup">
            <div className="success_login_bg_height">
                <div className="success_login_bg_width">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 success_login_bg_width_left">
                            <img
                                className="centerImage"
                                src={cogniLogo}
                                alt="Assistant"
                                title="Assistant"
                            />
                            <h2 className="pwd_reset_underline">
                                Check your inbox for a password reset link
                            </h2>
                            <p>
                                {' '}
                                You will receive a password reset link if the
                                below email is valid:{' '}
                            </p>
                            <h4>{props.email}</h4>
                            <div className="success_left_bottom_img">
                                <img
                                    src={SuccessImage}
                                    align="middle"
                                    alt="Login_img"
                                    title="Login_img"
                                />
                            </div>
                            <h6>
                                Didn’t get the link?
                                <span
                                    className={
                                        !timer.show && !invalidEmail.show
                                            ? ''
                                            : 'workspace_button_opacity'
                                    }
                                    onClick={() => reSend(props.email)}
                                >
                                    Resend
                                </span>
                                {timer.show && (
                                    <span
                                        style={{
                                            color: '#494949',
                                            paddingLeft: 5,
                                        }}
                                    >
                                        {'0' + Math.floor(timer.timer / 60)} :{' '}
                                        {timer.timer % 60 < 10
                                            ? '0' + (timer.timer % 60)
                                            : timer.timer % 60}{' '}
                                    </span>
                                )}
                            </h6>
                            {invalidEmail.show && (
                                <p style={{ color: '#ff7900' }}>
                                    {invalidEmail.msg}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </span>
    )
}
